export default __webpack_public_path__ + "static/media/power-bi.ad483d26.svg";